/**
 * The Microsoft four-square logo, in Microsoft's own brand colours.
 *
 * Used on the sign-in button, which is what Microsoft's identity branding guidance asks
 * for: the logo sits to the left of the label so the button reads as a genuine Microsoft
 * sign-in rather than a generic one.
 */
export function MicrosoftLogo({ size = 18 }: { size?: number }): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="1" y="1" width="9" height="9" fill="#f25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
      <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
      <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
    </svg>
  );
}
